import React from 'react';

import { useState, useEffect } from 'react';


import axios from 'axios';



import LoadingButton from 'components/Shared/LoadingButton';




type Props = {
    reclamationId: number
}

export default function RelancerIntegrationLitige({ reclamationId } : Props) {

    const [retrying, setRetrying] = useState(false);

    // Relance
    useEffect(() => {

        const retry = () => {
            axios.post(`api/reclamations/${reclamationId}/relancer-integration-litige`)

                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    // always executed
                    setRetrying(false);
                });
        };

        if (retrying) {
            retry();
        }

    }, [reclamationId, retrying]);
    

    return (
        <LoadingButton
            onClick={() => setRetrying(true)}
            label="Relancer"
            pending={retrying}
            color={"primary"}
            disabled={false}
            icon={null}
            mode={""}
            style={{}}
            tooltip={""}
        />      
    );
}